export default __webpack_public_path__ + "static/media/playButtonAlt.6997cd04.png";